var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.$t("seller.addInvitationCode"),
        visible: _vm.newCodeDialog,
        "custom-class": "drawerClass",
        direction: "ltr",
        size: "520px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.newCodeDialog = $event
        },
        close: _vm.handleNewCodeDialog,
      },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "0 20px" } },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "search-form",
              attrs: {
                inline: false,
                model: _vm.addForm,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("navbar.siteName"),
                            prop: "siteId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.addForm.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "siteId", $$v)
                                },
                                expression: "addForm.siteId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("customerManagements.AccountName"),
                            prop: "userName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("userManage.pleaseInput"),
                              clearable: "",
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.addForm.userName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addForm,
                                  "userName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "addForm.userName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "receivablePayable.deliveryVehicleType"
                            ),
                            prop: "deliveryVehicleType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                "collapse-tags": "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.addForm.deliveryVehicleType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addForm,
                                    "deliveryVehicleType",
                                    $$v
                                  )
                                },
                                expression: "addForm.deliveryVehicleType",
                              },
                            },
                            _vm._l(
                              _vm.deliveryVehicleTypeList,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictDescribe,
                                    value: item.dictName,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("seller.deliveryPrice"),
                            prop: "deliveryPrice",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("userManage.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.addForm.deliveryPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "deliveryPrice", $$v)
                              },
                              expression: "addForm.deliveryPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.submitForm },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("GlobalSetObj.determine")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }